import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../services/document.service';
import { SignatureModalComponent } from '../signature-modal/signature-modal.component';
import jsPDF from 'jspdf';
import { DataserviceService } from '../dataservice.service';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import * as pdfjsLib from 'pdfjs-dist';

@Component({
  selector: 'app-sign-document',
  templateUrl: './sign-document.component.html',
  styleUrls: ['./sign-document.component.css'],
})
export class SignDocumentComponent implements OnInit {
  showSignatureModal = false;
  currentSignatureField: any = null;
  zoomLevel: number = 1;
  canvasWidth!: number;
  canvasHeight!: number;
  currentUser: any;
  currentTextField: any = null;
  currentDateField: any = null;
  currentDoc: any;
  pdf: any;
  savingDoc: boolean = false;
  dateModal: boolean = false;

  selectedField: any;
  selectedFieldDiv: any;

  docValues = {};

  scaleX: any;
  scaleY: any;

  signModal: boolean = false;
  constructor(
    private documentService: DocumentService,
    private data: DataserviceService,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  }

  ngOnInit() {
    (pdfjsLib as any).GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
    this.currentDoc = this.modalRef.getConfig()?.nzData?.doc;
    this.renderPdf()
  }

  async renderPdf() {
    const arrayBuffer = await this.currentDoc.blob.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    this.pdf = pdf;
    const container = document.getElementById('pdf-container');
    if (!container) return;
    container.innerHTML = '';

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const scale = 1.5;
      const viewport = page.getViewport({ scale });
  
      // Create canvas
      const canvas = document.createElement('canvas');
      canvas.id = `pdfpage-${pageNum}`;
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvas.style.display = 'block';
  
      const context = canvas.getContext('2d');
      if (!context) continue;
  
      await page.render({ canvasContext: context, viewport }).promise;
  
      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';
      wrapper.style.width = `${canvas.width}px`;
      wrapper.style.height = `${canvas.height}px`;
      wrapper.style.margin = '1rem auto';
  
      wrapper.appendChild(canvas);
      const fieldsOnPage = this.currentDoc.fields.filter((f: any) => f.pageNum === pageNum);
      const scaleX = canvas.width / this.currentDoc.originalCanvasWidth;
      const scaleY = canvas.height / this.currentDoc.originalCanvasHeight;
  
      fieldsOnPage.forEach((field: any) => {
        const fieldDiv = document.createElement('div');
        fieldDiv.classList.add('field-overlay');
        fieldDiv.style.position = 'absolute';
        fieldDiv.style.left = `${field.x * scaleX}px`;
        fieldDiv.style.top = `${field.y * scaleY}px`;
        fieldDiv.style.width = `${field.width * scaleX}px`;
        fieldDiv.style.height = `${field.height * scaleY}px`;
        
        fieldDiv.style.border = '2px dashed black'; 
        fieldDiv.style.background = 'lightgray';         
        fieldDiv.style.color = 'black';           
        
        fieldDiv.style.fontSize = '16px';
        fieldDiv.style.fontWeight = 'bold';
        fieldDiv.style.display = 'flex';
        fieldDiv.style.justifyContent = 'center';
        fieldDiv.style.alignItems = 'center';
        fieldDiv.innerText = field.type == 'checkbox' ? '' : field.placeholder || field.name || field.type || 'Field';
        fieldDiv.style.cursor = 'pointer';
        
        fieldDiv.addEventListener('click', () => {
          this.onFieldClick(field, fieldDiv);
        });

        wrapper.appendChild(fieldDiv);
      });
  
      container.appendChild(wrapper);
    }
  }
  
  onFieldClick(field: any, fieldDiv: any) {
    field.value = field.value ? field.value : null;
    this.selectedField = field;
    this.selectedFieldDiv = fieldDiv;
    if(this.selectedField.type != 'signature') {
      this.dateModal = true;
    }else {
      this.onSignatureClick()
    }
  }

  onSignatureClick() {
    const modal = this.modal.create({
      nzTitle: 'Signature',
      nzContent: SignatureModalComponent,
      nzStyle: { top: '10px' },
      nzCentered: true, 
      nzFooter: null
    });

    modal.afterClose
      .subscribe((res) => {
        if(res) {
          this.selectedField.value = res
          this.selectedFieldDiv.innerHTML = '';

          const img = document.createElement('img');
          img.src = this.selectedField.value; 
          img.style.width = '100%'; 
          img.style.height = '100%';
          img.style.objectFit = 'contain';
        
          this.selectedFieldDiv.appendChild(img);
        
          this.selectedFieldDiv.style.border = 'none';
          this.selectedFieldDiv.style.background = 'none';
          this.selectedFieldDiv.style.justifyContent = 'start';
          this.selectedFieldDiv.style.alignItems = 'center';
        }
      })
  }

  onDateFieldOk() {
    if(this.selectedField.type == 'date' && this.selectedField.value) {
      this.selectedField.value = this.formatShortDate(new Date(this.selectedField.value))
    }

    if(this.selectedField.value) {
      if(this.selectedField.type == 'checkbox') {
        this.selectedFieldDiv.innerText = this.selectedField.value ? '✓' : '';
      }else {
        this.selectedFieldDiv.innerText = this.selectedField.value || this.selectedField.placeholder || this.selectedField.name || this.selectedField.type;
      }
      this.selectedFieldDiv.style.border = 'none';
      this.selectedFieldDiv.style.background = 'none'
      this.selectedFieldDiv.style.justifyContent = 'start';
      this.selectedFieldDiv.style.alignItems = 'end';

      this.docValues = {
        ...this.docValues,
        [this.selectedField?.name || '']: this.selectedField?.value
      };
   
    }

    this.dateModal = false;
    this.selectedField = null;
    this.selectedFieldDiv = null;
  }

  async saveSignedDocumentToSupabase() {
    this.savingDoc = true;
    const doc = new jsPDF({ unit: 'px' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
  
    for(let pN = 1; pN <= this.pdf.numPages; pN++) { 
      const canvas = document.getElementById(`pdfpage-${pN}`)! as HTMLCanvasElement;
      const imageData = canvas.toDataURL('image/png');
  
      if (pN > 1) {
        doc.addPage();
      }
  
      const scaleX = pageWidth / canvas.width;
      const scaleY = pageHeight / canvas.height;
      const scale = Math.min(scaleX, scaleY);
  
      const imgWidth = canvas.width * scale;
      const imgHeight = canvas.height * scale;
  
      doc.addImage(imageData, 'PNG', 0, 0, imgWidth, imgHeight);
  
      const fieldsOnPage = this.currentDoc.fields.filter((f: any) => f.pageNum === pN);
  
      fieldsOnPage.forEach((field: any) => {
        const x = field.x * scale;
        const y = field.y * scale;
        const w = field.width * scale;
        const h = field.height * scale;
  
        if (field.type === 'checkbox' && field.value) {
          doc.setFontSize(16);
          doc.text('x', x, y + h ); // align check
        } else if (field.type === 'signature' && field.value) {
          doc.addImage(field.value, 'PNG', x, y, w, h);
        } else if (field.value) {
          doc.setFontSize(12);
          doc.text(field.value.toString(), x + 2, y + 12);
        }
      });
    }
  
    const formattedDate = new Date().toISOString().split('T')[0];
    const pdfBlob = doc.output('blob');
    const path = `signed-documents/${this.currentDoc.document_id}-${this.currentUser.first_name}-${this.currentUser.last_name}-${formattedDate}`;
  
    const result = await this.data.uploadSignedDoc(path, pdfBlob);

    if (result) {
      let obj =  {
        document_id: this.currentDoc.document_id,
        filePath: path,
        doc_values: this.docValues
      }

      this.data.postData(obj, 'user-template-signatures/doc-signed')
        .subscribe({
          next: (res: any) => {
            this.savingDoc = false;
            this.modalRef.close()
          }
        })
    } else {
      console.error('❌ Upload failed');
    }
  }
  
  
  

  // canFinishSigning(): boolean {
  //   if(this.currentDoc) {
  //     return this.currentDoc.textFields.every((field: any) =>  field.textInput) && this.currentDoc.signatureFields.every((field: any) =>  field.signature);
  //   } else {
  //     return false
  //   }
  // }

  formatShortDate(date: Date): string {
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    const yy = date.getFullYear() % 100;
  
    return `${mm}/${dd}/${yy}`;
  }
}
